<div>
  <div>
    <div class="message" [ngClass]="messageClass">{{ message }}</div>
    <div class="input-container">
      <input
        #inputField
        type="text"
        pInputText
        [(ngModel)]="chronoTag"
        [pKeyFilter]="'int'"
        (keypress)="markSensor($event)"
        inputmode="numeric"
        [disabled]="!sensorsList.length"
      />
    </div>
  </div>
  <div class="check">
    <p-checkbox
      name="group1"
      label="Показывать возвращённые датчики"
      [(ngModel)]="showReturned"
      [binary]="true"
    ></p-checkbox>
  </div>
  <div class="sensors-list">
    <div *ngFor="let sensor of sensorsList" class="sensor-number">
      <ng-container *ngIf="!sensor.returnedAt || showReturned"
        >{{ sensor.clTag }} {{ sensor.name }} {{ sensor.city.split("$")[2] }}
        {{ sensor.phone }}
        <ng-container *ngIf="sensor.returnedAt">
          {{ sensor.returnedAt  | date : "dd.MM.yyyy HH:mm" }}
        </ng-container></ng-container
      >
    </div>
  </div>
</div>
